/* eslint-disable react/sort-comp */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Alert } from 'react-bootstrap';
import moment from 'moment';

// eslint-disable-next-line css-modules/no-unused-class
import s from './HoursList.scss';
import messages from './messages';

class MissingHoursAlert extends React.Component {
  static contextTypes = {
    client: PropTypes.object.isRequired,
  };
  static propTypes = {
    user: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    intl: intlShape.isRequired,
  };

  render() {
    const { user } = this.props;
    const daysUntilEndOfMonth = moment()
      .endOf('month')
      .diff(moment(), 'days');
    const displayMonthlyAlert = daysUntilEndOfMonth <= 5;

    return (
      user.missingHoursEntries.length > 0 &&
      user.missingHoursAlert && (
        <>
          {displayMonthlyAlert && (
            <div style={{ paddingLeft: '15px', paddingRight: '15px' }}>
              <Alert
                bsStyle="warning"
                style={{
                  borderLeft: '5px solid',
                  borderBottom: '1px solid',
                  borderRight: '1px solid',
                }}
              >
                <h4 style={{ lineHeight: 1.5 }}>
                  {displayMonthlyAlert && (
                    <>
                      <FormattedMessage
                        {...messages.missingHoursMonthlyAlert}
                      />{' '}
                      {daysUntilEndOfMonth}
                      <br />
                    </>
                  )}
                </h4>
              </Alert>
            </div>
          )}
          <div style={{ paddingLeft: '15px', paddingRight: '15px' }}>
            <Alert
              bsStyle="warning"
              style={{
                borderLeft: '5px solid',
                borderBottom: '1px solid',
                borderRight: '1px solid',
              }}
            >
              <h4 style={{ lineHeight: 1.5 }}>
                <FormattedMessage {...messages.missingHoursGeneral} />
                <br />
                <ul>
                  {user.missingHoursEntries
                    .slice(0, 10)
                    .map(date => <li key={date}>{date}</li>)}
                  {user.missingHoursEntries.length > 10 && (
                    <li>
                      ... {user.missingHoursEntries.length - 10} more missing
                      entries
                    </li>
                  )}
                </ul>
              </h4>
            </Alert>
          </div>
        </>
      )
    );
  }
}

export default injectIntl(withStyles(s)(MissingHoursAlert));
